import React from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import BootstrapTable2 from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
// es6
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

class HistoricalUnitPricesTable extends React.Component {

    constructor(props) {
        super(props);
        this.state ={
        }
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.refreshPagination){
            this.node.paginationContext.currPage= 1;
            this.props.setRefreshPagination(false);
        }
    }

    componentDidUpdate(){
        const pageDropDownButton = document.getElementById('pageDropDown');
        pageDropDownButton.innerHTML = "show : 10 items per page" +
            '<span><span><span className="caret"></span></span>'
    }

    sizePerPageUpdated(sizePerPage){
        const pageDropDownButton = document.getElementById('pageDropDown');
        pageDropDownButton.innerHTML = "show : " + sizePerPage + " items per page" +
            '<span><span><span className="caret"></span></span>'
    }

    render(){

        let firstTableHeader = this.props.FirstTableHeader;
        let tabledataMap =[];
        this.props.FindByReportTypeData.map((item) => {
            tabledataMap.push({
                date:  item.fundExitValueDate,
                entryPrice: item.fundEntryValue,
                exitPrice: item.fundExitValue,
            })
        })
        let fundName = "";
        if(this.props.FindByReportTypeData[0]){
            fundName = firstTableHeader + " - " + this.props.FindByReportTypeData[0].fundDescription;
        }

        const options = {
            page: 1,  // which page you want to show as default
            sizePerPageList: [ {
              text: 'show: 10 items per page ', value: 10
            }, {
              text: 'show: 25 items per page ', value: 25
            }, {
              text: 'show: 30 items per page ', value: 30
            },{
              text: 'show: 50 items per page ', value: 50
            } ],
            onSizePerPageChange: (sizePerPage, page) => {
                this.sizePerPageUpdated(sizePerPage);
            },
        };

        const columns = [
            {
                dataField: 'date',
                text: 'Date',
                headerClasses:'historical-table-header',
                headerAttrs: { scope: 'col' },
                classes : 'historical-date-column',
                attrs:{ scope : 'row'}
            },
            {
                dataField: 'entryPrice',
                text: 'Entry Price',
                headerClasses:'historical-table-header',
                headerAttrs: { scope: 'col' },
                classes : 'historical-other-column'
            },
            {
                dataField: 'exitPrice',
                text: 'Exit Price',
                headerClasses:'historical-table-header',
                headerAttrs: { scope: 'col' },
                classes : 'historical-other-column'
            }
        ];

        return(
            <div className="historical-table-width">
                <h3 className="header3-historical">{fundName}</h3>
                <BootstrapTable2
                    keyField="id"
                    hover={ true }
                    data={ tabledataMap }
                    bordered={ false }
                    classes = "historical-table"
                    ref={(n) => (this.node = n)}
                    columns = {columns}
                    pagination={ paginationFactory(options) }
                >
                </BootstrapTable2>
            </div>
        )
    }
}

export default HistoricalUnitPricesTable;
